import {
  faHouse,
  faEnvelope,
  faArrowAltCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { SubdomainOrgIdObject } from "./FunctionsAndInterfaces";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";

const orgId: number = 1622018741;
const subDomain: string = "radius";
const nameOfProduct: string = "RD";
const secureRouteGroups: string[] = ["Radius"];
const editableRightsGroup: string = "RADIUSEDITINGRIGHTS";

export const radiusObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
  editableRightsGroup: editableRightsGroup,
};

export const radiusNonEditableLiveboards = [
  "a150f297-d669-46ee-aa7c-00df60269294",
  "134f6cf8-9220-40d6-9bbe-0eea740b2dd5",
  "63b7bbec-f1eb-48c8-8546-e73d2f511bd4",
  "a150f297-d669-46ee-aa7c-00df60269294",
  "c6cf27aa-948d-4a1e-abd4-82d2aa3d3c6f",
  "d68c6e67-7a38-4e09-a704-9d2d35c3fbb6",
  "c408f361-a9ee-43a1-bb76-d480dc7f5ec4",
  "202f87f1-4928-4ab1-941b-d62629f54e9a",
  "5d3ac5e4-a7cb-40fe-9df3-a795d6d89ccf",
  "217a9026-88b0-494c-9f2f-bad2a52457c3",
  "f2e85da6-a388-4744-83ed-c2a1216e2c5b",
  "c1d644b4-3cab-41c1-bfa1-07a291b560e4",
  "ac730227-72a2-407d-ba07-32f74d4ffc50",
  "598efe96-fc33-4c00-bd23-dd8229d5e9e5",
  "5bebdc5a-f456-40e9-881b-fed7aa415dd9",
  "0a625779-812d-4674-86cf-d3f7bd2c24f7",
  "916e036a-2d25-4970-aa1e-285928f7a7c9",
  "be969d40-92ca-4dd4-81f4-8330a4bdaa89",
  "8cc510c0-7cf8-42a0-8caf-4f5d426d5e13",
  "223c8545-2261-4ee9-936a-4f9151156040",
  "742d1bc8-df54-463d-a119-4e7c6eb53ae9",
  "7eca149a-73bc-4a55-8a4e-15e2022a066f",
  "751acab1-775c-4f68-9353-156cb22a43fb",
  "242ec0a4-79ae-48d5-b4b9-be93061e4c85",
  "8f95f06f-2620-4316-9646-097364566f24",
  "213d9c45-6798-413d-877e-79cd95f15516",
  "6649fe38-710e-46d9-ab4b-dee9059bafba",
  "134f6cf8-9220-40d6-9bbe-0eea740b2dd5",
  "4b5c6faa-efca-45ff-b3d7-986de7f027a2",
  "0f5e71aa-2009-4aee-9f79-28b961847a90",
  "ba229734-26a9-4e87-906d-5e6ff201fd10",
  "22ee8894-bc83-4331-a477-86cbea8d6d13",
  "c777a30d-cc99-44eb-aea2-70e31781bfcd",
  "177e0020-18ca-42cb-bc64-ec3f8bea1d1b",
  "a41d5f0a-86ef-44c6-b862-666344625c81",
  "5744afe1-e0fc-4f04-b18a-160565e3a808",
  "42b58a63-cafe-4502-8c32-6e276334c43a",
  "de9de8ce-764a-479a-9492-909a77c94696",
  "205d74fb-55f4-46f5-92e3-03efd9505f6f",
  "bbfc8707-161f-4dff-88d6-807ad728db37",
  "760873ce-3402-4f69-90d4-baf287aae5e5",
  "4e579d0b-7c1c-40a5-8f36-910ac8aa9ab8",
  "35f281fd-ac4a-416e-8d71-d41accf326c1",
  "ab5b6fd0-3046-408e-962e-fc1338c8970f",
  "8df840d4-8eac-4560-a9df-1432f3afd1b9",
  "153b44ae-69b9-4c51-8406-89017ec38c2a",
  "d9ef26d5-fe10-433e-a6f5-788ff875b1b0",
  "debc23a4-b208-4b73-bb63-32bdfa1624fe",
  "4afb1144-a4e0-4be0-bd53-4617b7a38cf4",
  "f55cf41d-6e34-4e53-88f2-c8659588de69",
  "df36eca2-7b07-409e-958a-ba89a62dd043",
  "75dc5bc0-3c0d-47c8-be80-69306bce2d25",
  "8a72158a-8b28-41c8-8621-ed0c02b8e7b9",
  "3676e8b2-cd23-4587-8716-ff09e8b03e81",
  "b9f9d094-2e77-497c-ab5d-c5e156860fa4",
  "effa0423-bb77-4c80-ba0e-a33416f5fbf8",
  "3999e49e-8b2f-4c8e-b583-ed46e7792ef9",
  "e71fd9d9-dd64-4fd2-bb1f-36d4e8214090",
  "b68304f5-ba21-481d-b0bd-82907b9d043f",
  "ff883867-05f2-4d86-9426-ccc81de32b8f",
  "b79968db-ec9f-448a-a715-e60e3190c934",
  "c90f4904-5adc-4af2-a377-5908f721756b",
  "3bcdd45c-6b9f-44b5-866a-dbe82f2376dd",
  "c2516482-1b38-45ed-9528-206b92b7be9d",
  "446e317f-6887-4b22-90a2-88cf4dba35cc",
  "887f789c-a6f2-486a-85e4-49aabd076884",
  "38f5e6d8-513c-401f-907a-e8e27fd7b52e",
  "2bd7eccb-f870-4ac4-908c-6a0c83c5fe68",
  "9fd20744-fa1d-4af9-9c1e-fa673a013269",
  "c341699f-a37c-4ca4-9b6b-2a9e063af072",
];

const sidebarMenu = () => {
  return (
    <>
      <MenuItem>
        <Link to={`/${subDomain}/?productURL=pinboards&fromMenu=true`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faHouse} />
            Home
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/contactus`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/signout`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};

export const radiusRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: <Redirect redirectTo={`/${subDomain}/product`} />,
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              disableEditButtonArray={radiusNonEditableLiveboards}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={radiusObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
